import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "التقدم المحرز في مجال التعليم",
  "lead": "ينير التعليم كل مرحلة من مراحل السعي إلى مستقبل أفضل. ويحتاج جميع الأطفال إلى الانتفاع من تعليم نوعي يتيح لهم  اكتشاف امكاناتهم في التعلّم والإستفادة من المنافع الأوسع للتعليم. ولا بد من بذل جهود خاصة بغية ضمان استفادة جميع الأطفال والشباب بشكل متكافئ من القوة التحويلية للتعليم. ويتطلب ذلك موارد كافية، ولا سيما من أجل الوصول إلى من هم في أمس الحاجة إلى الدعم."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["ينير التعليم كل مرحلة من مراحل السعي إلى مستقبل أفضل. ويحتاج جميع الأطفال إلى ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "الانتفاع"
        }), " من تعليم ", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "نوعي"
        }), " يتيح لهم اكتشاف امكاناتهم في ال", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "تعلّم"
        }), " والإستفادة من المنافع الأوسع للتعليم. ولا بد من بذل جهود خاصة بغية ضمان استفادة جميع الأطفال والشباب بشكل ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "متكافئ"
        }), " من القوة التحويلية للتعليم. ويتطلب ذلك ", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "موارد"
        }), " كافية، ولا سيما من أجل الوصول إلى من هم في أمس الحاجة إلى الدعم."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["في عام 2015، اعتمد المجتمع الدولي 17 هدفاً للتنمية المستدامة يجب تحقيقها بحلول عام 2030، بما فيها رابع أهداف التنمية المستدامة الخاص بالتعليم. ومنذ ذلك الحين، وُضع ", _jsx(_components.a, {
          href: "https://unesco-gem-report.interactivethings.io/ar/indicator",
          children: "إطار مفصل"
        }), " لرصد التقدّم المحرز على صعيد تحقيق هذا الهدف. ويقدّم هذا الموقع ملخَّصاً لأهم الوقائع والاتجاهات السائدة في مجال التعليم في جميع أرجاء العالم بالتركيز على خمسة مواضيع:"]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsx(_components.p, {
        children: "ويستكمل المعلومات الواردة في النسخة المطبوعة من [التقرير العالمي لرصد التعليم]، وهو أداة المجتمع الدولي لمتابعة التقدّم المحرز على صعيد تحقيق رابع أهداف التنمية المستدامة الخاص بالتعليم واستعراض ذلك التقدّم."
      })
    }), "\n", _jsx(LandingButton, {
      children: "ابدأ القراءة"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
